import { unicommerceIntegrationActionTypes } from '../../actions/integrations/unicommerceIntegrationActions';

const UnicommerceIntegrationReducers = (state = { }, action) => {
  switch (action.type) {
  case unicommerceIntegrationActionTypes.GET_UNICOMMERCE_CONNECTIONS.LOADING: {
    const { getUnicommerceConnectionsLoading } = action;
    return {
      ...state,
      getUnicommerceConnectionsLoading,
    };
  }
  case unicommerceIntegrationActionTypes.GET_UNICOMMERCE_CONNECTIONS.SUCCESS: {
    const { unicommerceConnections } = action;
    return {
      ...state,
      unicommerceConnections,
    };
  }

  case unicommerceIntegrationActionTypes.CONNECT_TO_UNICOMMERCE.LOADING: {
    const { connectToUnicommerceLoading } = action;
    return {
      ...state,
      connectToUnicommerceLoading,
    };
  }

  case unicommerceIntegrationActionTypes.CONNECT_TO_UNICOMMERCE.SUCCESS: {
    const { connectedToUnicommerce } = action;
    return {
      ...state,
      connectedToUnicommerce,
    };
  }

  case unicommerceIntegrationActionTypes.VERIFY_LOCATION.LOADING: {
    const { verifyLocationLoading } = action;
    return {
      ...state,
      verifyLocationLoading,
    };
  }

  case unicommerceIntegrationActionTypes.CONNECT_TENANT_TO_LOCATION_UNICOMMERCE.LOADING: {
    const { connectTenantToLocationLoading } = action;
    return {
      ...state,
      connectTenantToLocationLoading,
    };
  }

  case unicommerceIntegrationActionTypes.SYNC_PRODUCT.LOADING: {
    const { syncProductsLoading } = action;
    return {
      ...state,
      syncProductsLoading,
    };
  }

  case unicommerceIntegrationActionTypes.SYNC_SO.LOADING: {
    const { syncSOLoading } = action;
    return {
      ...state,
      syncSOLoading,
    };
  }
  case unicommerceIntegrationActionTypes.ADJUST_UNICOMMERECE_INVENTORY.LOADING: {
    const { adjustUnicommerceInventoryLoading } = action;
    return {
      ...state,
      adjustUnicommerceInventoryLoading,
    };
  }
  case unicommerceIntegrationActionTypes.UPDATE_UNICOMMERCE_CONFIGURATION.LOADING: {
    const { updateUnicommerceConfigurationLoading } = action;
    return {
      ...state,
      updateUnicommerceConfigurationLoading,
    };
  }
  case unicommerceIntegrationActionTypes.SCHEDULE_UNICOMMERCE_SYNC.LOADING: {
    const { scheduleUcSyncLoading } = action;
    return {
      ...state,
      scheduleUcSyncLoading,
    }
  }
  case unicommerceIntegrationActionTypes.DELETE_UNICOMMERCE_SYNC.LOADING: {
    const { deleteUcSyncLoading } = action;
    return {
      ...state,
      deleteUcSyncLoading,
    }
  }
  default: {
    return state;
  }
  }
};

export default UnicommerceIntegrationReducers;
